import {
  COLORS,
  COMMON_STYLES,
  formatCurrency,
  PARAGRAPH_STYLES,
  SUBHEADING_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import React from 'react'
import { StyleSheet, Text, View } from 'react-native'

interface Props {
  totalAmount: number
  totalDiscount: number
  shippingCharges: number
  couponAmount?: number
  insuranceCharges?: number
  couponCode?: string
}

const BillDetails = ({
  totalAmount,
  totalDiscount,
  shippingCharges,
  couponAmount = 0,
  insuranceCharges,
  couponCode,
}: Props) => {
  const amount = totalAmount - totalDiscount
  const finalPrice =
    amount - couponAmount + shippingCharges + (insuranceCharges || 0)
  return (
    <View style={styles.container}>
      <Text
        style={[
          TYPOGRAPHY.HEADING3,
          VARIANTS_STYLES.EMPHASIZED,
          TEXT_STYLES.textNeutral90,
        ]}
      >
        Bill Detail
      </Text>
      <BillRow name={'Item Total'} value={amount} />
      {couponCode && couponAmount ? (
        <CouponRow couponCode={couponCode!} discount={couponAmount} />
      ) : (
        <BillRow name={'Coupon Applied'} value={0} />
      )}
      <BillRow name={'Delivery Charges'} value={shippingCharges} />
      {insuranceCharges !== undefined ? (
        <BillRow name={'Insurance Charges'} value={insuranceCharges} />
      ) : null}
      <TotalRow value={finalPrice} />
    </View>
  )
}

interface BillRowProps {
  name: string
  value?: number
}

const BillRow = ({ name, value }: BillRowProps) => {
  return (
    <View style={styles.row}>
      <Text style={[PARAGRAPH_STYLES.RegularT2, TEXT_STYLES.textNeutral80]}>
        {name}
      </Text>
      <Text style={[PARAGRAPH_STYLES.RegularT2, TEXT_STYLES.textNeutral80]}>
        {value !== undefined ? formatCurrency(value) : 'NIL'}
      </Text>
    </View>
  )
}

const CouponRow = ({
  couponCode,
  discount,
}: {
  couponCode: string
  discount?: number
}) => {
  return (
    <View style={styles.row}>
      <View style={COMMON_STYLES.row}>
        <Text style={[PARAGRAPH_STYLES.RegularT2, TEXT_STYLES.textNeutral80]}>
          Coupon Applied
        </Text>
        <Text style={[PARAGRAPH_STYLES.RegularT2, TEXT_STYLES.textNeutral80]}>
          {` (${couponCode})`}
        </Text>
      </View>
      <Text style={[PARAGRAPH_STYLES.RegularT2, TEXT_STYLES.textNeutral70]}>
        - {discount !== undefined ? formatCurrency(discount) : 'NIL'}
      </Text>
    </View>
  )
}

const TotalRow = ({ value }: { value: number }) => {
  return (
    <View style={[styles.row, styles.borderTop, COMMON_STYLES.pt1]}>
      <Text
        style={[
          TYPOGRAPHY.TEXT1,
          VARIANTS_STYLES.SEMI_EMPHASIZED,
          TEXT_STYLES.textNeutral80,
        ]}
      >
        Total Amount
      </Text>
      <Text
        style={[
          TYPOGRAPHY.TEXT1,
          VARIANTS_STYLES.SEMI_EMPHASIZED,
          TEXT_STYLES.textNeutral80,
        ]}
      >
        {value !== undefined ? formatCurrency(value) : 'NIL'}
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  borderTop: {
    borderTopColor: COLORS.neutral20,
    borderTopWidth: 1,
  },
  container: {
    backgroundColor: COLORS.white,
    paddingHorizontal: 32,
    paddingVertical: 16,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 8,
  },
})

export default BillDetails
